// *** NUMBER SERVICE ***

// *** COMPARE TWO NUMBERS ***
export const compareNumbers = (value1, value2) => {
    // returns true if equal
    const number1 = parseInt(value1);
    const number2 = parseInt(value2);
    return (number1 !== number1 && number2 !== number2) || number1 === number2; // NaN check in parentheses
};
